{
  "exportEntries": {
    "exportToCsv": "Exportar a CSV",
    "exportMessage": "El archivo CSV se descargará automáticamente en su dispositivo, si no es así, verifique la configuración de su navegador",
    "columnNames": {
      "code": "Código",
      "quantity": "Cantidad",
      "name": "Nombre",
      "price": "Precio"
    },
    "exportProductToCsv": "Descargar productos"
  },
  "importEntries": {
    "importProducts": "Importar productos"
  },
  "importEntriesDialog": {
    "importProducts": "Importar productos",
    "importProductsSubtitle": "Agregue productos importando un archivo .CSV.",
    "importProductsNewSavedCartSubtitle": "Agregue productos importando un archivo .CSV y creando un nuevo carrito guardado.",
    "importProductFileDetails": "El archivo de texto debe contener una lista de productos con las columnas requeridas separadas por una coma: SKU y cantidad.",
    "selectFile": "Seleccionar archivo",
    "savedCartName": "Nombre del carrito guardado",
    "savedCartDescription": "Descripción del carrito guardado",
    "optional": "opcional",
    "charactersLeft": "caracteres restantes: {{count}}",
    "cancel": "Cancelar",
    "upload": "Subir",
    "close": "Cerrar",
    "summary": {
      "info": "No cierre ni actualice esta ventana mientras se están importando los productos.",
      "loadedToCart": "Los productos se han cargado en el carrito {{ cartName }}",
      "loaded": "Los productos se han cargado",
      "loading": "Los productos se están procesando... ({{ count }}/{{ total }})",
      "successes": "{{ successesCount }} de {{ total }} productos se han importado correctamente.",
      "warning": "{{ count }} producto no se importó totalmente.",
      "warning_other": "{{ count }} productos no se importaron totalmente.",
      "error": "{{ count }} producto no se importó.",
      "error_other": "{{ count }} productos no se importaron.",
      "messages": {
        "unknownIdentifier": "El SKU del producto \"{{ productCode}}\" no existe.",
        "lowStock": "La cantidad para {{ productName }}: {{ quantity }} se ha reducido a {{ quantityAdded }}.",
        "noStock": "{{ productName }} está actualmente agotado.",
        "unknownError": "Problema no reconocido con \"{{ productCode }}\".",
        "limitExceeded": "No se puede agregar \"{{ productCode }}\". Límite excedido."
      },
      "show": "Mostrar",
      "hide": "Ocultar"
    }
  }
}
